import { useSelector } from 'react-redux';

import { selectGeneralSettings } from '../services/selectors';

export const useDefaultAccessRole = () => {
    const { defaultPermission } = useSelector(selectGeneralSettings);

    return defaultPermission;
};
